module.exports = __webpack_public_path__ + "static/media/folder.8fc6a49b.svg";